module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQ1JREFUeNqEk01qAkEQhdvRlTlFFgoiaMwYEf+iEV2EhBzAw+hFcgGXbhQjqOBPFBcakLj3HDq+gmooihmn4GP6dc3rbqq6I57nlYwxBbAFKxMez6AGDhGYeyIxDlnABZ9WOGAgkm1QCjC+SCNiRDvTIA8+RGIBJkLTMd+EptzCYbEDc5GsgCKPM8r4y4sbu7ONBngV+gjSQm/A0AptpqiDKoiKuQvv+CN/dHwKMwN/au6kjUHmHEiquUe+C3fN1Mcv8MD6zN84eAflILOr+rgE3+q4LXkPrDmljHthWnKV5UV6stVO4NtRfRz51KLJXbDRJ3OXFgkx+t6DGFiDLL0Sfhj3YgquXPn/mwADAK/5QxcnWW9yAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tipIcon3.png
// module id = scpK
// module chunks = 42